import React from "react";
import Button from "components/bootstrap/Button";
import { Icon } from "components/common";
import useHasUndeclaredParameters from "views/logic/parameters/useHasUndeclaredParameters";
import useHotkey from "hooks/useHotkey";
const SaveAsDashboardButton = ({ onClick, openSaveAsModal }) => {
  const hasUndeclaredParameters = useHasUndeclaredParameters();
  useHotkey({
    actionKey: "save-as",
    callback: () => openSaveAsModal(),
    scope: "dashboard",
    options: { enabled: !hasUndeclaredParameters }
  });
  return /* @__PURE__ */ React.createElement(Button, { onClick, disabled: hasUndeclaredParameters, title: "Save as new dashboard" }, /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" }), " Save as");
};
export default SaveAsDashboardButton;
